<template>
  <div class="text-center bg-custom-purple h-screen">
    <img
      src="@/assets/images/survey/done-icon.png"
      class=" mt-20 lg:w-32"
      style="width: 60%;"
    />
    <div class="mt-20">
      <h1 class="font-bold text-5xl">Thank you!</h1>
      <br />
      <h2>Form submitted</h2>
    </div>
  </div>
</template>

<script>
import { vsImage } from "vuesax";

export default {
  components: {
    vsImage
  }
  // other component options
};
</script>
